import { Component, OnInit } from "@angular/core";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-courses-page",
    templateUrl: "./courses-page.component.html",
    styleUrls: ["./courses-page.component.scss"],
})
export class CoursesPageComponent implements OnInit {
    constructor(private titleService: TitleService) {}

    ngOnInit(): void {
        this.titleService.setTitle("University");
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "University",
        },
    ];
    singleCoursesBox: coursesContent[] = [
        {
            courseImg: "assets/img/funfacts/kepler.png",
            courseImgClass: "kepler",
            coursePrice: "Free",
            coursePriceClass: "free",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "Kepler",
            link: "university-kepler",
            paragraphText:
                "An entry-level overview designed for data engineers and data analysts as a basic introduction to the Kepler Platform.",
            courseDuration: "45 minutes",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/funfacts/mdp-logo-removebg-preview.png",
            courseImgClass: "mdp",
            coursePrice: "Free",
            coursePriceClass: "free",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "MDP",
            link: "university-mdp",
            paragraphText:
                "This entry-level overview is designed for data engineers and data analysts as a basic introduction to the MDP Platform.",
            courseDuration: "45 minutes",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/funfacts/UDA.png",
            courseImgClass: "uda",
            coursePrice: "Free",
            coursePriceClass: "free",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "UDA",
            link: "university-uda",
            paragraphText:
                "This entry-level overview is designed for data engineers and data analysts as a basic introduction to the UDA Platform.",
            courseDuration: "45 minutes",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/courses/snowflake.png",
            courseImgClass: "",
            coursePrice: "$49",
            coursePriceClass: "paid",
            authorImg: "assets/img/user2.jpg",
            authorName: "Sarah Taylor",
            title: "Snowflake",
            link: "university-snowflake",
            paragraphText:
                "A beginner’s guide designed to help navigate the Snowflake interface and introduce some of the core capabilities.",
            courseDuration: "90 minutes",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/blog/img1.jpg",
            courseImgClass: "",
            coursePrice: "$69",
            coursePriceClass: "paid",
            authorImg: "assets/img/user3.jpg",
            authorName: "David Warner",
            title: "Azure Data Management",
            link: "azure-dataexplorer",
            paragraphText:
                "A gentle introduction to Azure Data Explorer (ADX) and Azure Data Factory (ADF)",
            courseDuration: "2 Hours",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/courses/kusto.png",
            courseImgClass: "",
            coursePrice: "$99",
            coursePriceClass: "paid",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "Kusto Query Language",
            link: "university-kusto",
            paragraphText:
                "Learn to explore data, discover patterns, identify anomalies/outliers, and more with Kusto Query Language.",
            courseDuration: "40 minutes",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/courses/openshift-foundation.png",
            courseImgClass: "",
            coursePrice: "$49",
            coursePriceClass: "paid",
            authorImg: "assets/img/openshift-foundation.png",
            authorName: "Sarah Taylor",
            title: "Red Hat OpenShift",
            link: "openshift-foundation",
            paragraphText:
                "The course introduces the foundations of OpenShift to get hands-on experience creating and deploying applications.",
            courseDuration: "4 Hours",
            studentApply: "Self-Paced",
        },
        {
            courseImg: "assets/img/courses/airflow.jpg",
            courseImgClass: "airflow",
            coursePrice: "$65",
            coursePriceClass: "paid",
            authorImg: "assets/img/airflow.jpg",
            authorName: "David Warner",
            title: "Airflow",
            link: "university-airflow-training",
            paragraphText:
                "This tutorial walks through the fundamentals of Airflow concepts, objects, and their usage.",
            courseDuration: "4 Hours",
            studentApply: "Self-Paced",
        },
    ];
}
class pageTitle {
    title: string;
}
class coursesContent {
    courseImg: string;
    courseImgClass: string;
    coursePrice: string;
    coursePriceClass: string;
    authorImg: string;
    authorName: string;
    title: string;
    link: string;
    paragraphText: string;
    courseDuration: string;
    studentApply: string;
}
